module.exports = __webpack_public_path__ + "img/60.526069a8.jpg";